/**
 * Превью объекта в карточке каталога — его символ, вписанный в карточку.
 *
 * Одно на каталог чертежа и каталог в 3D, чтобы карточки выглядели одинаково. Предмет
 * на полу показывается сверху (ширина × глубина), а настенный и потолочный — спереди
 * (ширина × высота): сверху розетка — полоска в 20 мм, растянутая на всю карточку,
 * она выходит жирной и сплющенной.
 */
import { CatalogAttach, type CatalogItem } from "@/shared/catalog";
import { CatalogSymbol } from "./CatalogSymbol";

interface Props {
	item: CatalogItem;
	/** Сколько экранных пикселей в превью по большей стороне — от него толщина линий заглушки */
	sizePx?: number;
}

export const CatalogItemPreview = ({ item, sizePx = 120 }: Props) => {
	const front = item.attach === CatalogAttach.OnlyWall || item.attach === CatalogAttach.Ceiling;
	const w = item.width;
	const h = front ? item.height : item.depth || item.height;
	const pad = Math.max(w, h) * 0.2;
	const vw = w + pad * 2;
	const vh = h + pad * 2;
	const mmPerPx = Math.max(vw, vh) / sizePx;

	return (
		<svg
			viewBox={`${-w / 2 - pad} ${-h / 2 - pad} ${vw} ${vh}`}
			className="size-full drop-shadow-sm"
			preserveAspectRatio="xMidYMid meet"
		>
			<CatalogSymbol item={item} width={w} height={h} color="#475569" mmPerPx={mmPerPx} />
		</svg>
	);
};
